import { createAction, props } from '@ngrx/store';

export const sendErrorNotification = createAction(
  '[Core.Auth0ErrorNotificationActions] Send Error Notification',
  props<{ failedEndpoint: string }>()
);
export const sendErrorNotificationSuccess = createAction(
  '[Core.Auth0ErrorNotificationActions] Send Error Notification Success'
);
